module.exports = __webpack_public_path__ + "img/b2.7bd85f65.png";